import React from 'react';
import { useFormContext } from 'react-hook-form';
import i18n from '../../I18n';
import { CustomTitleLabel } from '../earning/CustomBaseComponments';
import CustomEditor from 'components/base/CustomEditor';
import CustomTitleWithInput from '../base/CustomTitleWithInput';
import './AppUpdateContent.scss';

const AppUpdateContent = ({
  language,
}) => {
  const { watch, setValue } = useFormContext();
  const forceUpdateTitleField = `translations.${language}.forceUpdateTitle`;
  const forceUpdateDescriptionField = `translations.${language}.forceUpdateDescription`;
  const optionalUpdateTitleField = `translations.${language}.optionalUpdateTitle`;
  const optionalUpdateDescriptionField = `translations.${language}.optionalUpdateDescription`;

  const forceUpdateTitle = watch(forceUpdateTitleField);
  const forceUpdateDescription = watch(forceUpdateDescriptionField);
  const optionalUpdateTitle = watch(optionalUpdateTitleField);
  const optionalUpdateDescription = watch(optionalUpdateDescriptionField);

  return (
    <>
      <div className="first-section-title">
        {i18n.t('forceUpdateNotice', { locale: language })}
      </div>
      <CustomTitleWithInput
        title={i18n.t('title', { locale: language })}
        tips={i18n.t('forceUpdateTitleTips', { locale: language })}
        defaultValue={forceUpdateTitle}
        setValue={(value) => {
          setValue(forceUpdateTitleField, value, { shouldDirty: true, });
        }}
      />
      <CustomTitleLabel
        title={i18n.t('description', { locale: language })}
      />
      <label className="tips-message">{i18n.t('forceUpdateDescriptionTips', { locale: language })}</label>
      <CustomEditor
        initialValue={forceUpdateDescription}
        onValueChange={(data) => {
          setValue(forceUpdateDescriptionField, data, { shouldDirty: true });
        }}
      />

      <div className="first-section-title app-update-optional-notice">
        {i18n.t('optionalUpdateNotice', { locale: language })}
      </div>
      <CustomTitleWithInput
        title={i18n.t('title', { locale: language })}
        tips={i18n.t('optionalUpdateTitleTips', { locale: language })}
        defaultValue={optionalUpdateTitle}
        setValue={(value) => {
          setValue(optionalUpdateTitleField, value, { shouldDirty: true, });
        }}
      />
      <CustomTitleLabel
        title={i18n.t('description', { locale: language })}
      />
      <label className="tips-message">{i18n.t('optionalUpdateDescriptionTips', { locale: language })}</label>
      <CustomEditor
        initialValue={optionalUpdateDescription}
        onValueChange={(data) => {
          setValue(optionalUpdateDescriptionField, data, { shouldDirty: true });
        }}
      />
    </>
  );
}

export default AppUpdateContent;
